export const tabletInfoMessages = {
  kmGenerator: {
    title: "Exfluency CREATE",
    description:
      "Draft, refine, and publish multilingual content that fits your brand – from marketing copy to technical docs and policy text.",
    description2: "CREATE keeps everything consistent by using your knowledge base.",
    iconPath: "/exfluency/icons/icon-CREATE.svg"
  },
  kmChat: {
    title: "Exfluency ASK",
    description: "ASK is a prompt-based search engine that only works with the data in your knowledge base/s.",
    description2:
      "If the answer isn’t in your data, ASK tells you. No guesses. No hallucinations. Just your data, made clear.",
    iconPath: "/exfluency/icons/icon-ASK.svg"
  },
  knowledgeBase: {
    title: "Knowledge Base",
    description: "The Knowledge Base is where your data lives – private and ready to use.",
    description2:
      "It powers ASK and CREATE by giving them the context they need to deliver accurate, consistent results.",
    iconPath: "/exfluency/portal-icon_data-sources.svg"
  },
  aiTextTranslator: {
    title: "AI Text Translator",
    description: "Enter your text, choose a language, and get a clear translation instantly.",
    description2: "Bonus tip: Save translations to your Knowledge Base to improve quality and consistency over time.",
    iconPath: "/exfluency/icons/icon-ai-text-trans.svg"
  },
  aiFileTranslator: {
    title: "AI File Translator",
    description: "Translate your documents in record time – while keeping your data safe.",
    description2: "Upload files, choose a target language, and download translations with the original layout intact.",
    description3:
      "Bonus tip: Save your translated files to your Knowledge Base to improve accuracy and consistency across future work.",
    iconPath: "/exfluency/icons/icon-ai-file-trans.svg"
  },
  myProfile: {
    title: "My profile",
    description: "My Profile is where you manage your account details.",
    description2: "Update your name, email, and  password, or adjust your preferences when needed.",
    iconPath: "/exfluency/portal-icon_profil.svg"
  }
}
